import {
  AfterViewInit,
  Component,
  ContentChild,
  ElementRef,
  Input,
  OnChanges,
  SimpleChanges,
  TemplateRef,
  ViewEncapsulation,
  inject,
} from '@angular/core';
import { TakeUntilDestroy } from '@shared/decorators/take-until-destroy.decorator';
import { SharedModule } from '@app/shared/shared.module';
import { ShopOffersItemType } from '@app/shared/models/shop-offers.model';

export interface EventProgressBarData {
  points: number;
  reward?: number;
  rewardMultiplier?: number;
  currency?: ShopOffersItemType;
  redeemed?: boolean;
}

@Component({
  selector: 'slotcom-event-progress-bar',
  templateUrl: './event-progress-bar.component.html',
  styleUrls: ['./event-progress-bar.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [SharedModule],
})
@TakeUntilDestroy
export class EventProgressBarComponent implements AfterViewInit, OnChanges {
  @ContentChild('eventProgressBarIntervalContent', { read: TemplateRef }) intervalTemplate!: TemplateRef<unknown>;

  @Input() classes: Array<string> = [];
  @Input() totalProgress: number = 0;
  @Input() currentProgress: number = 0;
  @Input() eventProgressBarData: EventProgressBarData[];
  @Input() animated = false;

  firstLoad: boolean = false;
  currentStep: number = 0;
  animationsAmount: number = 0;

  iconStates: boolean[] = [];
  iconStateAssets: string[] = [];

  private readonly elRef = inject(ElementRef);

  constructor() {
    this.firstLoad = true;
  }

  ngAfterViewInit() {
    this.setElementsPosition();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.setElementsPosition();

    const progressBars: HTMLElement[] = this.elRef.nativeElement.getElementsByClassName('c-progress__fill');

    for (const progressBar of progressBars) {
      if (!this.firstLoad && this.animated) {
        progressBar.animate(
          [
            {
              width: `${(changes?.currentProgress?.previousValue * 100) / this.totalProgress}%`,
            },
            {
              width: `${(changes?.currentProgress?.currentValue * 100) / this.totalProgress}%`,
            },
          ],
          {
            duration: 1000,
            iterations: 1,
          }
        );
      }

      const w = this.getProgressWidth();
      progressBar.style.width = `${w}%`;
      this.firstLoad = false;
    }
  }

  private getProgressWidth(): number {
    return Number(`${(this.currentProgress * 100) / this.totalProgress}`);
  }

  private setElementsPosition(): void {
    const intervals: HTMLElement[] = this.elRef.nativeElement.getElementsByClassName('interval');

    Array.from(intervals).forEach((interval, i) => {
      if (i > 0) {
        const width = Number(
          `${((this.eventProgressBarData[i].points - this.eventProgressBarData[i - 1].points) / this.totalProgress) * 100}`
        );
        interval.style.width = `${width}%`;
      } else {
        interval.style.width = '0';
      }
    });
  }
}
